// yyyy-mm-dd -> dd.mm.yyyy
export const formatDate = (iso) => {
  if (!iso) return ""
  const [y, m, d] = String(iso).split("-")
  return y && m && d ? `${d}.${m}.${y}` : iso
}
